module.exports = __webpack_public_path__ + "static/media/third_declension3_img.0cabf057.JPG";